import CreateScenarioDialog from 'components/Dialog/ScenarioDialog';
import TabsBarsDescriptors from 'components/TabsBars/TabsBarsDescriptors';
import { actions as scenariosActions } from 'ducks/scenarios';
import ExpandableScenarioConfig from 'pages/ScenarioExposure/Product/ScenariosManagement/ExpansionBar';
import ERCAmbiente from 'pages/ScenarioExposure/Product/ScenariosManagement/ERCAmbiente';
import PROCTrabalhadores from 'pages/ScenarioExposure/Product/ScenariosManagement/PROCTrabalhadores';
import PCProduto from 'pages/ScenarioExposure/Product/ScenariosManagement/PCProduto';
import SUSectores from 'pages/ScenarioExposure/Product/ScenariosManagement/SUSectores';
import BackgroundQuestion from 'pages/ScenarioExposure/sharedComponents/BackgroundQuestion';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  filterByFieldSelector, groupBy, mixtureSubstancesBySubstance, shipmentsByRawMaterial
} from 'selectors/generic';
import { SCENARIO_EP } from 'utils/constants/coreConstants';
import { ERC_TAB, PC_TAB, PROC_TAB, SU_TAB } from 'utils/constants/descriptorTypes';
import { lcsExternalExposure } from 'utils/constants/lcsTypes';
import { TABLE_HEIGHT } from 'utils/ui/constants';

const TABLE_HEIGHT_QUESTION = TABLE_HEIGHT(false, 100);

const Component = props => {
  const {
    compositionByProduct, compositionByRawMaterial, lcssFactory, lcssById,
    mixtureSubstancesById, mixtureSubstancesBySubstance, substanceId, rawMaterialsById,
    scenarioDescriptorsData, scenariosById, scenariosData, shipmentsByRawMaterial,

    shipmentInitializer, scenarioInitializer
  } = props;
  const {
    closeScenarioManagement, createScenario, fetchScenarios, setSubstanceId,

    setShipmentInitializer, setScenarioInitializer
  } = props;

  const [createScenarioOpen, setCreateScenarioOpen] = useState(false);
  const handleCreateScenarioClose = () => setCreateScenarioOpen(false);
  const handleCreateScenarioOpen = () => setCreateScenarioOpen(true);

  /**  ******* Shipment initialization  ***********  */
  // Fetches Shipments from direct substance and from mixtures where substance might be in
  const shipmentInitialization = substance => {
    let shipment = {};
    const shipmentsOfSubstance = shipmentsByRawMaterial[substance.id] || [];
    const mixturesOfSubstance = mixtureSubstancesBySubstance[substance.id] || [];
    if (shipmentsOfSubstance.length > 0) {
      shipment = {
        ... shipmentsOfSubstance[0],
        shipment_substance_id: substance.id,
        shipment_id_mp: substance.id,
        raw_material_name: substance.name,
        raw_material_code: substance.code,
      };
    } else if (mixturesOfSubstance.length > 0) {
      const mixIds = mixturesOfSubstance.map(mix => mix.mixture_id);
      let shipmentsFromMix = [];
      mixIds.forEach(id => {
        (shipmentsByRawMaterial[id] || []).forEach( shipt =>
          shipmentsFromMix.push({
            ...shipt,
            shipment_mixture_id: id,
            shipment_id_mp: id,
            raw_material_name: rawMaterialsById[id].name,
            raw_material_code: rawMaterialsById[id].code,
          })
        );
      });
      if (shipmentsFromMix.length > 0) {
        shipment = shipmentsFromMix[0];
      }
    }
    return shipment;
  };
  /**  ******* Shipment initializarion END  ***********  */

  const scenarioInitialization = () => {
    const scenarios = scenariosData.filter(s =>
      s.raw_material_supplier_id === shipment.id && parseInt(s.lcs_id) === lcs.id
    );
    return scenarios.length > 0 ? scenarios[0].id : null;
  };

  const substance = rawMaterialsById[substanceId];
  // lcssFactory is filtered from the descriptors, so an account whose
  // reference data has none of that type gets an empty list rather than a
  // first element.
  const defaultLcsId = lcssFactory[0]?.id || null;
  const [lcsId, setLcsId] = useState(scenarioInitializer?.lcs_id || defaultLcsId);
  const lcs = lcssById[lcsId];
  const [shipment, setShipment] = useState(shipmentInitializer ? shipmentInitializer : null);
  const [scenarioId, setScenarioId] = useState(scenarioInitializer ? scenarioInitializer.id : null);
  const scenario = scenariosById[scenarioId];
  const [loading, setLoading] = useState(null);
  const [descriptorTab, setDescriptorTab] = useState(PC_TAB);

  useEffect(() => {
      if (shipmentInitializer) {
        setShipmentInitializer(null);
      } else {
        setShipment(shipmentInitialization(substance));
      }
    }, [substanceId]
  );

  useEffect(() => {
      if (scenarioInitializer) {
        setScenarioInitializer(null);
      } else {
        setScenarioId(scenarioInitialization());
      }
    },
    [substanceId, shipment, lcsId, scenariosData]
  );

  /**  ******* Exposure Scenario information  ***********  */
  const scenarios = scenariosData.filter(s =>
    s.raw_material_supplier_id === shipment.id && parseInt(s.lcs_id) === lcs.id
  );
  /**  ******* Exposure Scenario information END ***********  */

  /**  ******* Product Scenario information  ***********  */
  // substance.products, the m2m through the composition rows: one entry per
  // row, repetitions included, which the Set below removes as it always did.
  const productsOfSubstance = (compositionByRawMaterial[substanceId] || [])
    .map(composition => composition.product_id);
  let productsSubstanceRelevantIds = [];
  if (shipment.shipment_id_mp === substanceId) {
    /**
     * CASE#1 if shipment comes from substance only have to check substance for products and
     * if products appear have to check for substance presence=TRUE and campo_3FDS=TRUE for substance
     * This will allow me to filter Scenarios By product to find later the ScenarioDescriptors
     */
    const productsSubstancePresentIds = [ ... new Set(productsOfSubstance) ];
    productsSubstanceRelevantIds = productsSubstancePresentIds.filter( pID =>
      (compositionByProduct[pID] || []).some( pMp =>
        pMp.raw_material_id === substanceId &&
        !pMp.mixture_substance_id &&
        pMp.contributes_to_hazard &&
        !pMp.excluded_from_final_product
      )
    );
  } else {
    /**
     * CASE#2 if shipment is through mixture only have to check mixture for products and
     * intesect with checking substance for products and then if there is intersection of product
     * have to check for presence and campo 3FDS
     */
    const productsSubstancePresentIds = [ ... new Set(productsOfSubstance) ];
    productsSubstanceRelevantIds = productsSubstancePresentIds.filter( pID =>
      (compositionByProduct[pID] || []).some( pMp =>
        pMp.raw_material_id === substanceId &&
        (pMp.mixture_substance_id &&
          mixtureSubstancesById[pMp.mixture_substance_id].mixture_id === shipment.shipment_id_mp) &&
        pMp.contributes_to_hazard &&
        !pMp.excluded_from_final_product
      )
    );
  }

  const productScenarios = scenariosData.filter(s =>
    parseInt(s.lcs_id) === lcs.id && productsSubstanceRelevantIds.includes(s.product_id)
  );
  const productScenariosIds = productScenarios.map( pS => pS.id);

  const productScenarioDescriptors = scenarioDescriptorsData.filter( scenarioDescriptor =>
    productScenariosIds.includes(scenarioDescriptor.scenario_id)
  );

  /**  ******* Product Scenario information END  ***********  */

  const newScenario = (code, description, notes) => {
    setLoading(true);
    createScenario({
      substance_id: substanceId,
      raw_material_supplier_id: shipment.id,
      code: code,
      designation: description,
      lcs_id: lcs.id,
      type: SCENARIO_EP
    })
      .then(() => {
        fetchScenarios();
      })
      .finally(() => {
        setCreateScenarioOpen(false);
        setLoading(false);
      });
  };

  const CreateScenarioQuestion = () => {
    return (
      <BackgroundQuestion
        bodyHeight={TABLE_HEIGHT_QUESTION}
        label='Criar cenário'
        onClick={handleCreateScenarioOpen}
        submitting={loading}
      >
        <div>
          <p>
            O cenário seleccionado para a combinação de Substância <b>{rawMaterialsById[substanceId].name}</b>,
            LCS <b>{lcs.description}</b> e Fornecimento <b>{shipment.trade_name}</b> não existe, pretende criá-lo?
          </p>
        </div>
      </BackgroundQuestion>
    );
  };

  const WorkingArea = descriptorTab => {
    switch (descriptorTab) {
      case PC_TAB:
        return (
          <PCProduto
            productScenarioDescriptors={productScenarioDescriptors}
            lcs={lcs}
            scenario={scenario}
            substanceId={substanceId}
          />
        );

      case SU_TAB:
        return (
          <SUSectores
            productScenarioDescriptors={productScenarioDescriptors}
            lcs={lcs}
            scenario={scenario}
            substanceId={substanceId}
          />
        );

      case ERC_TAB:
        return (
          <ERCAmbiente
            productScenarioDescriptors={productScenarioDescriptors}
            lcs={lcs}
            scenario={scenario}
            substanceId={substanceId}
          />
        );

      case PROC_TAB:
        return (
          <PROCTrabalhadores
            productScenarioDescriptors={productScenarioDescriptors}
            lcs={lcs}
            scenario={scenario}
            substanceId={substanceId}
            // TODO BELOW NOT NEED PROBABLY ON PRODUCT TOPIC
            // Extra data needed to know the flows in use and take out steps/MPS
            productScenarios={productScenarios}
          />
        );
    }
  };


  return (
    <React.Fragment>
      <ExpandableScenarioConfig
        currentOptionSubstance={substance}
        onSelectionSubstance={setSubstanceId}
        currentOptionLcs={lcs}
        onSelectionLcs={setLcsId}
        currentOptionShipment={shipment}
        onSelectionShipment={setShipment}
        scenarios={scenarios}
        currentOptionScenario={scenario}
        onSelectionScenario={setScenarioId}
        handleCreateScenarioOpen={handleCreateScenarioOpen}
        closeScenarioManagement={closeScenarioManagement}
      />
      <TabsBarsDescriptors value={descriptorTab} setValue={setDescriptorTab}/>

      {
        scenario ?
          WorkingArea(descriptorTab) :
          CreateScenarioQuestion()
      }
      {
        createScenarioOpen &&
        <CreateScenarioDialog
          open={createScenarioOpen}
          code={`${rawMaterialsById[substanceId].name}_${shipment.code}_${lcs.description}`}
          description={lcs.description}
          handleClose={handleCreateScenarioClose}
          handleSubmit={newScenario}
        />
      }
    </React.Fragment>
  );
};

const makeMapStateToProps = () => {
  const lcssFactory = filterByFieldSelector('descriptors', 'id', lcsExternalExposure);
  // The composition rows from both sides: by raw material for the products a
  // substance is in, by product to ask what that substance does inside one.
  const compositionByProduct = groupBy('productRawMaterials', 'product_id');
  const compositionByRawMaterial = groupBy('productRawMaterials', 'raw_material_id');
  const mapStateToProps = (state, props) => ({
    compositionByProduct: compositionByProduct(state),
    compositionByRawMaterial: compositionByRawMaterial(state),
    lcssFactory: lcssFactory(state),
    lcssById: state.descriptors.models,
    mixtureSubstancesById: state.mixtures.models,
    mixtureSubstancesBySubstance: mixtureSubstancesBySubstance(state),
    rawMaterialsById: state.rawMaterials.models,
    scenariosData: state.scenarios.data,
    scenariosById: state.scenarios.models,
    scenarioDescriptorsData: state.scenarioDescriptors.data,
    shipmentsByRawMaterial: shipmentsByRawMaterial(state),
    shipmentsById: state.rawMaterialSuppliers.models,
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  createScenario: data => dispatch(scenariosActions.createPromise(data)),
  fetchScenarios: () => dispatch(scenariosActions.fetchAll())
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
